/**
 * Скролл к верху страницы
 */
class ScrollUp {
    constructor(btn) {
        this.btn = btn;
        this.smController = new ScrollMagic.Controller();

        this.bindClick();
        this.pinButton();
    }

    bindClick() {
        this.btn.addEventListener('click', () => {
            $('html, body').animate({
                scrollTop: 0
            }, 500);

            if (App.H.is('._is-fullpage')) {
                App.H.trigger('fullpage.scrollTop');
            }
        });
    }

    pinButton() {
        const scene = new ScrollMagic.Scene({
            triggerElement: document.querySelector('.footer'),
            triggerHook: 1,
            offset: 0,
            duration: 0
        });

        scene
            .addTo(this.smController)
            .on('enter', () => this.btn.classList.remove('_is-fixed'))
            .on('leave', () => this.btn.classList.add('_is-fixed'));
    }
}

document.querySelectorAll('.js-scroll-up').forEach(btn => {
    new ScrollUp(btn);
});



// WEBPACK FOOTER //
// ./_src/js/ScrollUp.js